import Slider from './Slider'
import Menu from './Menu'

document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.m-slider');
  for (const slider of sliders) {
    new Slider(slider);
  }

  const menu = document.querySelector('.m-navigation');
  if (menu) {
    new Menu(menu)
  }
})
